// extracted by mini-css-extract-plugin
module.exports = {"desktop":"responsive_desktop__j_QMR","mobile":"responsive_mobile__JjEnZ"};